import { UPDATETIMESHEETPROJECT_SUCCESS, UPDATETIMESHEETPROJECT_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const updateTimesheetProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATETIMESHEETPROJECT_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATETIMESHEETPROJECT_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateTimesheetProjectReducer;
